import { isBefore } from 'date-fns'

import { IAplDocument } from '../models/aplDocument'

import { parseDocumentMeta } from './parseDocumentMeta'

export const getLastUploadDate = (aplDocuments: IAplDocument[]): Date => {
  let result = new Date()

  for (const aplDocument of aplDocuments) {
    const meta = parseDocumentMeta(aplDocument.Meta)

    if (meta) {
      const uploadDate = new Date(meta.date)

      if (isBefore(uploadDate, result)) {
        result = uploadDate
      }
    }
  }

  return result
}
